import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

const MOBILE_BREAKPOINT = 768;

/**
 * Mappa un URL /web all'URL /app equivalente.
 * Ritorna null se non esiste un equivalente app valido (es. profilo).
 */
function webToAppUrl(url: string): string | null {
	// Login
	if (url.startsWith('/web/public/login')) return '/app/public/login';
	// Dettaglio pratica - estrazione di idTransaction
	const dettaglioMatch = url.match(/\/web\/private\/firma\/dettaglio\/([^/?]+)/);
	if (dettaglioMatch) return `/app/dashboard/dettaglio/${dettaglioMatch[1]}`;

	// Rotte di firma pubblica - non reindirizzare all'app, rimani sul web per lo switcher responsive
	if (url.includes('/web/public/firma-otp')) return null;

	// Home firma / qualsiasi pagina web autenticata → dashboard dell'app
	if (url.startsWith('/web/private')) return '/app/dashboard';
	// Fallback
	return '/app/public/login';
}

export const platformGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const isNative = Capacitor.isNativePlatform();
	const isMobileWidth = typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
	const target = route.data['platform'];
	const currentUrl = state.url;

	if (target === 'web' && isNative) {
		router.navigate(['/app/public/login']);
		return false;
	}

	if (target === 'app' && !isNative) {
		if (currentUrl.includes('/profilo')) {
			router.navigate([isMobileWidth ? '/app/dashboard' : '/web/private/firma']);
			return false;
		}
		if (!isMobileWidth) {
			router.navigate(['/web/public/login']);
			return false;
		}
		return true;
	}

	if (target === 'web' && !isNative && isMobileWidth) {
		const appUrl = webToAppUrl(currentUrl);
		if (appUrl) {
			router.navigate([appUrl]);
			return false;
		}
	}

	return true;
};
